import axios from "axios";
const _axiosInstance = axios.create({
  timeout: 15000,
});

function compile(code) {
  code = JSON.stringify(code);
  code = code.toString();
  let res = [];
  code.split("").map((c, i) => {
    res.push((code.charCodeAt(i) + 2).toString(16));
  });
  return res.join("");
}

export const getDateUtc = () => {
  var date = new Date();
  var y = date.getUTCFullYear();
  var m = date.getUTCMonth() + 1;
  var d = date.getUTCDate();
  var h = date.getUTCHours();
  var m1 = date.getUTCMinutes();
  var s = date.getUTCSeconds();
  return y + "-" + m + "-" + d + " " + h + ":" + m1 + ":" + s + " UTC";
};

export const getIOSVersion = function () {
  return (navigator.userAgent.match(/os\s+(\d+)/i) ? navigator.userAgent.match(/os\s+(\d+)/i)[1] : 0) - 0;
};

export const getUUID = () => {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
};

export const downloadApp = async (vueobj, ip, bid, cid, cc) => {
  let bookId = bid || 0;
  let chapterId = cid || 0;
  let channelCode = cc || 'GFWEB00001';
  let u = navigator.userAgent;
  let isIos = !!u.match(/.+Mac OS X/); //ios终端
  let adjustObj = {
    ip: ip,
    token: "yokse1",
    bookId: String(bookId),
    channelCode: channelCode,
    cId: String(chapterId),
    shareCode: "0",
    url: window.location.href,
    ua: navigator.userAgent,
    campaign: `gf_${channelCode}_${bookId}_yokse1_${chapterId}_${isIos ? "ios" : "and"}`
  };
  let formstr =
    JSON.stringify({
      bookId: String(bookId),
      channelCode: channelCode,
      cid: String(chapterId),
      event: "yokse1",
      extend: {
        sw: window.screen.width,
        sh: window.screen.height,
        ua: u,
        uuid: localStorage.getItem("UUID") ? localStorage.getItem("UUID") : getUUID(),
      },
      shareCode: "0",
      url: "",
      campaign: `gf_${channelCode}_${bookId}_yokse1_${chapterId}_${isIos ? "ios" : "and"}`
    });

  const url1 = "/hwycfm/business/load";
  _axiosInstance.get(url1, { params: { json: formstr, line: 4 } });
  try {
    var compileData = compile(adjustObj);
    var text = "ugv_" + compileData;
    if (getIOSVersion() && getIOSVersion() >= 16) {
      const dateUtc = getDateUtc();
      text = `https://www.goodfm.com CZ0001 89000000 ${dateUtc} ${text}`;
    }
    vueobj.$copyText(text).then(function (e) {
      console.log("succ", e);
    }, function (e) {
      console.log("err", e);
    });
  } catch (e) {
    console.log('try err', e);
  }
  setTimeout(() => {
    if (isIos) {
      if (getIOSVersion() >= 16) {
        window.location.href = "https://ul.goodfm.com/?nlq=" + JSON.stringify({ type: 0, json: adjustObj });
      } else {
        // let goodfmURL = `goodfm://open?bid=${bookId}&cid=${chapterId}&channelCode=${channelCode}&token=yokse1`;
        // window.location.href = "https://app.adjust.com/c8g5e0y?deeplink=" + encodeURIComponent(goodfmURL);
        const urlValue = `goodfm://gfAF?bid=${bookId}&cid=${chapterId}&channelCode=${channelCode}&token=yokse1`;
        const encodeUrlValue = encodeURIComponent(urlValue);
        window.location.href = `https://goodfm.onelink.me/9euv?af_xp=custom&pid=web&c=h5&deep_link_value=${encodeUrlValue}&af_dp=${encodeUrlValue}`;
      }
    } else {
      var compileTxt = "clr_" + compileData;
      window.location.href = "https://ap.goodfm.com/?nlq=" + encodeURIComponent(JSON.stringify({ type: 0, json: adjustObj })) + "&referrer=" + compileTxt;
    }

  });
};
